<template>
  <div class="function-upload-desctiption">
    <filter-panel
      style="width: 100%;"
      :data="group"
      @search="filterChange"
    ></filter-panel>
    <data-list
      :table-style="{ name: 'mixture' }"
      :data="data"
      :columns="columns"
      :loading="loading"
      :page="page"
      :page-size="page.pageSize"
      :btnList="btnList"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
    ></data-list>
    <dialog-form
      :dialogVisible="showDialog"
      :attributes="attributes"
      :formData="formData"
      @close:dialogVisible="(val) => (showDialog = val)"
      @confirm="confirm"
    ></dialog-form>
  </div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue'
import listPageCreate from '@/mixins/listPageCreate'
import api from '@/backend/apiConfig/apiConfig'
import dialogForm from '@/components/dialogForm/dialogForm'
import functionUpdateConfig from '@/components/setting/functionUpdateConfig.js'
import editText from '@/components/tools/edit_text'
import { functionStatus } from '@/common/dictionary'
import setting from '@/backend/services/setting/setting.js'
const list = listPageCreate({
  searchConfig: {
    api: api.setting.updateList,
    method: 'POST',
  },
})

export default {
  mixins: [list],
  data() {
    return {
      group: {},
      columns: [],
      btnList: [],
      showDialog: false,
      attributes: {
        title: '新增功能更新',
        width: '40%',
      },
      formData: {},
      disabled: false,
      versionId: false, // true 编辑 false 新增
    }
  },
  mounted() {
    this.setGroup()
    this.setListConfig()
    this.setFormData()
  },
  methods: {
    setGroup() {
      this.group = {
        others: [
          {
            tagName: 'sky-input',
            placeholder: '标题',
            label: '标题',
            prop: 'projectVersionNum',
            value: '',
          },
        ],
        multiples: [
          {
            defaultText: '系统端',
            placeholder: '系统端',
            label: '系统端',
            options: [
              { label: '全球赢Web客户端', value: 1 },
              { label: '全球赢小程序', value: 2 },
            ],
            prop: 'systemType',
            value: '',
          },
        ],
      }
    },
    setListConfig() {
      let that = this
      this.btnList = [
        {
          name: '新增',
          position: 'right',
          attribute: {
            type: 'primary',
            size: 'small',
          },
          btnClick() {
            that.versionId = false
            that.disabled = false
            that.setFormData({}, 'add')
            that.showDialog = true
          },
        },
      ]

      this.columns = [
        {
          label: '标题',
          bind: 'projectVersionNum',
        },
        {
          label: '更新说明',
          bind: 'explain',
          type: 'mapping',
          mapType: 'text',
          trigger: 'hover'
        },
        {
          label: '发布系统端',
          bind: 'systemTypeList',
          type: 'multiseriate',
          multiseriate(val) {
            if (!val) return []
            let obj = []
            val.forEach((item) => {
              let val = ''
              switch (item) {
                case '1':
                  val = '全球赢Web端'
                  break
                case '2':
                  val = '全球赢小程序'
                  break
                case '3':
                  val = '全球赢APP'
                  break
              }
              obj.push({
                value: val,
              })
            })
            return obj
          },
        },
        {
          label: '生效时间',
          bind: 'version',
          type: 'percentage',
          dataStyle(val, row) {
            let date = ''
            if (row.beginTime) {
              let start = row.beginTime && row.beginTime.slice(0, 10)
              date += start
            }
            if (row.endTime) {
              let end = row.endTime && row.endTime.slice(0, 10)
              date += '-'
              date += end
            }
            return date
          },
        },
        {
          label: '生效状态', //  即将生效可编辑，正在生效可编辑状态，关闭不可编辑
          type: 'custom',
          componentName: editText,
          bind({ status }) {
            switch (status) {
              case 1:
                return '正在生效'
              case 2:
                return '即将生效'
              case 3:
                return '已关闭'
              default:
                return '-'
            }
          },
          showButton(row) {
            if (row.status === 3) {
              return false
            } else {
              return true
            }
          },
          config({ status }) {
            let options =
              status === 1 ? [{ label: '已关闭', value: 3 }] : functionStatus
            return {
              componentType: 'sky-select',
              options,
            }
          },
          triggerEvent(row, data, cb) {
            that.updateStatus(row.id, data, cb)
          },
        },
        {
          label: '操作',
          type: 'btnClick',
          style: 'text',
          bind(row) {
            let { status, id } = row
            return [
              {
                text: '查看详情',
                trigger() {
                  that.viewDetail(id)
                },
              },
              {
                text: '编辑',
                showButton() {
                  return status === 2
                },
                trigger() {
                  that.redact(id)
                },
              },
            ]
          },
        },
      ]
    },
    // 改变状态
    async updateStatus(id, status, cb) {
      try {
        await setting.updateStatus({
          id,
          status,
        })
        this.$message.success('状态更新成功')
        this.query()
        cb()
      } catch (error) {
        this.$message.info('状态更新失败')
      }
    },
    // 查看详情
    async viewDetail(id) {
      try {
        let res = await setting.functionDetail({
          id,
        })
        this.disabled = true
        this.setFormData(res.data, 'view')
        this.showDialog = true
      } catch (error) {
        this.$message.info('获取详情数据失败')
      }
    },
    // 编辑
    async redact(id) {
      try {
        let res = await setting.functionDetail({
          id,
        })
        this.disabled = false
        this.versionId = res.data && res.data.id
        this.setFormData(res.data, 'redact')
        this.showDialog = true
      } catch (error) {
        this.$message.info('获取详情数据失败')
      }
    },
    setFormData(val, status) {
      let disabled = this.disabled
      let formData = functionUpdateConfig(val, disabled, status)
      this.formData = formData
    },
    async confirm(cb) {
      try {
        let { disabled, formData, versionId } = this
        if (disabled) {
          cb()
          return false
        }
        let params = {}
        if (versionId) {
          params.id = versionId
        }
        Object.keys(formData).map((key) => {
          params[key] = formData[key].value
        })
        await setting.addUpdate(params)
        this.query()
        this.$message.success('新增成功！')
        cb()
      } catch (error) {
        cb(false)
        this.$message.warning('新增失败！')
      }
    },
  },
  components: { filterPanel, dialogForm },
}
</script>
